import { FormCarteirinhaComponent } from './form-carteirinha/form-carteirinha.component';
import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  { path: 'carteirinha', component: FormCarteirinhaComponent}
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)],
  exports: [
    RouterModule
  ]
})
export class CarteirinhaRoutingModule { }
